import Layout1 from "../src/pages/Layout1/Layout1";
import PrivacyPolicy from "../src/pages/PrivacyPolicy/PrivacyPolicy";

const routes = [
  { path: "/", component: <Layout1 /> },
  { path: "/politica-de-privacidad", component: <PrivacyPolicy /> },
];

export default routes;
